import React, { useState, useEffect } from "react";
import { Link, useLocation } from "./../util/router";
import "./Navbar.scss"
import { NavBarButtons } from "./buttons/nav-bar-buttons";
import { useAuth0 } from "@auth0/auth0-react";
import { useMediaQuery } from 'react-responsive';

function Navbar(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState("");
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  const isSmallMobile = useMediaQuery({ query: '(max-width: 660px)' });  
  const isTablet = useMediaQuery({ query: '(max-width: 926px)' });
  const marginClassName = !isSmallMobile && isTablet ? 'margin-left' : ''  
  const navBarItemType = !isSmallMobile && isTablet ? 'navbar-item' : 'navbar-link'
    
  useEffect(() => {
    setActivePage(location.pathname);
  }, [location]);
    
  return (
    <nav
      className={
        "navbar" +
        (props.color ? ` is-${props.color}` : "") +
        (props.spaced ? " is-spaced" : "")
      }
    >
      <div className="container">
        <div className="brand-left">
          <Link to="/" className="main-logo-container ">
            <img src={props.logo} alt="Logo" />
          </Link>
          <div>
            <div
              className={"navbar-burger burger" + (menuOpen ? " is-active" : "")}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
        <div className={"navbar-menu is-align-items-center" + (menuOpen ? " is-active" : "")}>
          <div className="navbar-start nav-mobile">
            { isAuthenticated &&
              <div className="dropdown is-hoverable ml-1">
                <div className="dropdown-trigger">
                  <Link
                    className={`${navBarItemType} link-developer` + (activePage === "/developer" ? " is-active has-text-weight-bold" : "")}
                    to="/developer"                    
                    aria-haspopup="true" aria-controls="dropdown-menu"
                  >
                    <span className="icon is-small padding-icon">
                      <i className="fas fa-tools"></i>
                    </span>
                    Developer Portal
                    { !isSmallMobile && isTablet && 
                      <span className="icon is-small ml-2">
                        <i className="fas fa-angle-right" aria-hidden="true"></i>
                      </span>
                    }
                  </Link>            
                </div>
                <div className={`dropdown-menu ${marginClassName}`} id="dropdown-menu" role="menu">
                  <div className="dropdown-content">
                    <a                      
                      className="dropdown-item"
                      href="https://edzlabs.github.io/pds-slatedocs-web/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontSize: "1.25rem", borderWeight: "0px", paddingTop: "5px", paddingBottom: "5px", textAlign: "baseline", paddingRight: "20px"}}
                    > 
                      <span className="icon is-small" style={{paddingRight: "30px"}}>
                        <i className="fas fa-book"></i>
                      </span>
                      REST API Docs
                    </a>
                    <Link
                      className={"dropdown-item" + (activePage === "/helpdesk" ? " is-active has-text-weight-bold" : "")}
                      to="/helpdesk"
                      style={{fontSize: "1.25rem", borderWeight: "0px", paddingTop: "5px", paddingBottom: "5px", textAlign: "baseline", paddingRight: "20px"}}
                    >
                      <span className="icon is-small" style={{paddingRight: "30px"}}>
                        <i className="fas fa-question-circle"></i>
                      </span>
                      Helpdesk
                    </Link>
                    <Link
                      className={"dropdown-item" + (activePage === "/faucet" ? " is-active has-text-weight-bold" : "")}
                      to="/faucet"
                      style={{fontSize: "1.25rem", borderWeight: "0px", paddingTop: "5px", paddingBottom: "5px", textAlign: "baseline", paddingRight: "20px"}}
                    >
                      <span className="icon is-small" style={{paddingRight: "30px"}}>
                        <i className="fas fa-faucet"></i>
                      </span>
                      Testnet Faucet
                    </Link>
                    <a
                      className={"dropdown-item" + (activePage === "/npm-client-library" ? " is-active has-text-weight-bold" : "")}
                      href="https://www.npmjs.com/package/dsd-client-conn-lib"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontSize: "1.25rem", borderWeight: "0px", paddingTop: "5px", paddingBottom: "5px", textAlign: "baseline", paddingRight: "20px"}}
                    >
                      <span className="icon is-small" style={{paddingRight: "30px"}}>
                        <i className="fab fa-npm"></i>
                      </span>
                      Client Library
                    </a>
                    <a
                      className={"dropdown-item" + (activePage === "/npm-client-library" ? " is-active has-text-weight-bold" : "")}
                      href="http://docs-review.dase.io/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontSize: "1.25rem", borderWeight: "0px", paddingTop: "5px", paddingBottom: "5px", textAlign: "baseline", paddingRight: "20px"}}
                    >
                      <span className="icon is-small" style={{paddingRight: "30px"}}>
                        <i className="fas fa-book"></i>
                      </span>
                      Legacy Docs
                    </a>
                  </div>
                </div>
              </div>
            }            
            <Link
              className={"navbar-item link-aai" + (activePage === "/accountable-ai" ? " is-active has-text-weight-bold" : "")}
              to="/accountable-ai"
            >
              <span className="icon is-small padding-icon">
                <i className="fas fa-gavel"></i>
              </span>
                Accountable AI
            </Link>
            { isAuthenticated &&
              <Link
                className={"navbar-item link-apps" + (activePage === "/apps" ? " is-active has-text-weight-bold" : "")}
                to="/apps"                
              >
                <span className="icon is-small padding-icon">
                  <i className="fas fa-rocket"></i>
                </span>
                Apps
              </Link>
            }
          </div>
          <NavBarButtons menuOpen={menuOpen} activePage={activePage} />
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
